import { render, staticRenderFns } from "./cardTemplateVip25.vue?vue&type=template&id=942e6918&scoped=true&"
import script from "./cardTemplateVip25.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip25.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip25.vue?vue&type=style&index=0&id=942e6918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942e6918",
  null
  
)

export default component.exports